import { useState } from 'react';
import { IStockOrderDetail } from '../../../../../types/stockOrders';
import BillingProviderInfo from './components/BillingProviderInfo/BillingProviderInfo';
import StockOrderSummary from './components/StockOrderSummary/StockOrderSummary';

interface Tab3BillingProps {
  stockOrderData: IStockOrderDetail;
  updateWithoutLoaders: () => Promise<void>;
}

const Tab3Billing = ({ stockOrderData, updateWithoutLoaders }: Tab3BillingProps) => {
  const { billingData } = stockOrderData ?? {};

  const [providerOrderNumber, setProviderOrderNumber] = useState(billingData?.providerOrderNumber);
  const [providerInvoiceNumber, setProviderInvoiceNumber] = useState(billingData?.providerInvoiceNumber);

  return (
    <div className="tab3Billing">
      <BillingProviderInfo
        providerOrderNumber={providerOrderNumber}
        setProviderOrderNumber={setProviderOrderNumber}
        providerInvoiceNumber={providerInvoiceNumber}
        setProviderInvoiceNumber={setProviderInvoiceNumber}
        billingData={billingData}
        updateWithoutLoaders={updateWithoutLoaders}
      />
      <StockOrderSummary billingData={billingData} />
    </div>
  );
};

export default Tab3Billing;
